<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Case</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="edit-form-panel">
                <form [formGroup]="caseForm">
                    <div class="field-form-panel">
                        <h4>{{caseID > 0 ? 'Edit' : 'Add'}}</h4>
                        <hr />
                        <div class="flex-form contracts-flex-form">
                            <div class="form-group">
                                <label>Case Number</label>
                                <h6 *ngIf="caseID > 0">{{memCase?.caseNumber}}</h6>
                                <h6 *ngIf="caseID == 0">XXX-XXXXXX-XXX</h6>
                                <!--<input class="form-control" type="text" formControlName="caseNumber" />-->
                            </div>
                            <div class="form-group">
                                <label>Subject</label>
                                <input class="form-control" type="text" formControlName="subject" />
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <input class="form-control" type="text" formControlName="description" />
                            </div>
                            <div class="form-group">
                                <label>Case Resolution</label>
                                <input class="form-control" type="text" formControlName="caseResolution" />
                            </div>
                            <div class="form-group">
                                <label>Vessel Plus Location</label>
                                <input class="form-control" type="text" formControlName="vesselPlusLocation" />
                            </div>
                            <div class="form-group">
                                <label>Vessel No</label>
                                <input class="form-control" type="text" formControlName="vesselNo" />
                            </div>
                            <div class="form-group">
                                <label>Transaction Amount</label>
                                <input class="form-control" type="text" formControlName="transactionAmount" />
                            </div>
                            <div class="form-group">
                                <label>Invoice Link</label>
                                <input class="form-control" type="text" formControlName="invoiceLink" />
                            </div>
                            <div class="form-group">
                                <label>Days To Case Close</label>
                                <input class="form-control" type="text" formControlName="daysToCaseClose" />
                            </div>
                            <!--<div class="form-group">
                                <label>Case Open Age</label>
                                <input class="form-control" type="text" formControlName="caseOpenAge" />
                            </div>-->
                            <div class="form-group">
                                <label>Dock hand</label>
                                <input class="form-control" type="text" formControlName="dockhand" />
                            </div>
                            <div class="form-group">
                                <label>Incident Amount Total</label>
                                <input class="form-control" type="text" formControlName="incidentAmountTotal" />
                            </div>
                            <div class="form-group">
                                <label>Incident Description</label>
                                <input class="form-control" type="text" formControlName="incidentDescription" />
                            </div>
                            <div class="form-group">
                                <label>After Tax Amount</label>
                                <input class="form-control" type="text" formControlName="afterTaxAmount" />
                            </div>
                            <div class="form-group">
                                <label>Retail Cost Of Damage</label>
                                <input class="form-control" type="text" formControlName="retailCostOfDamage" />
                            </div>
                            <div class="form-group">
                                <label>Jet Ride Damage Savings</label>
                                <input class="form-control" type="text" formControlName="jetRideDamageSavings" />
                            </div>
                            <div class="form-group">
                                <label>Internal Comments</label>
                                <input class="form-control" type="text" formControlName="internalComments" />
                            </div>
                            <div class="form-group">
                                <label>Case Reason Description</label>
                                <input class="form-control" type="text" formControlName="caseReasonDescription" />
                            </div>
                            <div class="form-group">
                                <label>User Story</label>
                                <input class="form-control" type="text" formControlName="userStory" />
                            </div>
                            <div class="form-group">
                                <label>Web Email</label>
                                <input class="form-control" type="text" formControlName="webEmail" />
                            </div>
                            <div class="form-group">
                                <label>Web Company</label>
                                <input class="form-control" type="text" formControlName="webCompany" />
                            </div>
                            <div class="form-group">
                                <label>Web Name</label>
                                <input class="form-control" type="text" formControlName="webName" />
                            </div>
                            <div class="form-group">
                                <label>Filtering Attribute</label>
                                <input class="form-control" type="text" formControlName="filteringAttribute" />
                            </div>
                            <!--<div class="form-group">
                                <label>Created By</label>
                                <input class="form-control" type="text" formControlName="createdBy" />
                            </div>-->
                            <div class="form-group">
                                <label>Incident Date</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="incidentDate" class="form-control" formControlName="incidentDate" id="incidentDate">
                                    <mat-datepicker-toggle matSuffix [for]="incidentDate"></mat-datepicker-toggle>
                                    <mat-datepicker #incidentDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Incident DateTime</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="incidentDateTime" class="form-control" formControlName="incidentDateTime" id="incidentDateTime">
                                    <mat-datepicker-toggle matSuffix [for]="incidentDateTime"></mat-datepicker-toggle>
                                    <mat-datepicker #incidentDateTime></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Date Opened</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="dtOpened" class="form-control" formControlName="dtOpened" id="dtOpened">
                                    <mat-datepicker-toggle matSuffix [for]="dtOpened"></mat-datepicker-toggle>
                                    <mat-datepicker #dtOpened></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Date Closed</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="dtClosed" class="form-control" formControlName="dtClosed" id="dtClosed">
                                    <mat-datepicker-toggle matSuffix [for]="dtClosed"></mat-datepicker-toggle>
                                    <mat-datepicker #dtClosed></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Failed Inspection Level</label>
                                <select class="form-control" formControlName="failedInspectionLevel">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of ref_MemFailedInspectionLevel_List" [value]="item.levelID">{{item?.level}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Status ID</label>
                                <select class="form-control" formControlName="statusID">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of ref_MemCaseStatus_List" [value]="item.statusID">{{item?.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Protection Plan</label>
                                <select class="form-control" formControlName="protectionPlan">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of ref_MemProtectionPlan_List" [value]="item.statusID">{{item?.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Case Origin</label>
                                <select class="form-control" formControlName="caseOrigin">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of ref_MemCaseOrigin_List" [value]="item.originID">{{item?.origin}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Case Reason</label>
                                <select class="form-control" formControlName="caseReason">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of ref_MemCaseReason_List" [value]="item.reasonID">{{item?.reason}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Member Concern Level</label>
                                <select class="form-control" formControlName="memberConcernLevel">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of ref_MemCaseConcernLevel_List" [value]="item.levelID">{{item?.level}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Case Owner</label>
                                <select class="form-control" formControlName="caseOwnerId">
                                    <option *ngFor="let opt of clpUsersDD" [value]="opt.value">
                                        {{ opt.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Contact</label>
                                <select class="form-control" formControlName="contactId" (change)="onChangeMemContact()">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of memContact_dd" [value]="item.id">{{item?.text}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="primary-btn" *ngIf="caseID == 0" (click)="memCase_Create()">Save</button>
                    <button type="button" class="primary-btn" *ngIf="caseID > 0" (click)="memCase_Update()">Update</button>
                    <button type="button" class="black-btn" *ngIf="caseID > 0" (click)="memCase_Delete()">Delete</button>
                </form>
            </div>
        </div>
    </div>
</div>

